<div class="settings-dialog-overlay">
  <div class="settings-dialog-modal">
    <!-- Header -->
    <div class="settings-dialog-header">
      <span>Settings</span>
      <button class="close-button" (click)="close()">×</button>
    </div>
    <!-- Tabs -->
    <div class="settings-dialog-tabs">
      <button class="tab-btn" [class.active]="viewTab === 'tab-about'" (click)="changeTab('tab-about')">About</button>
      <button class="tab-btn" [class.active]="viewTab === 'tab-general'" (click)="changeTab('tab-general')">General</button>
      <button class="tab-btn" [class.active]="viewTab === 'tab-arcangel'" (click)="changeTab('tab-arcangel')">Illum Live</button>
      <button class="tab-btn" [class.active]="viewTab === 'tab-alerts'" (click)="changeTab('tab-alerts')">Alerts</button>
    </div>

    <!-- Content -->
    <div >
      <div>
        @switch (viewTab) {
          <!-- About Tab -->
          @case ('tab-about') {
            <div class="settings-dialog-content">
              <div class="about-title">IllumLive v2.2.0</div>
              <ul class="about-plugins">
                <li>Twitter Plugin v1.0</li>
                <li>Markers Plugin v1.0</li>
                <li>Measurement Plugin v1.0</li>
                <li>Patrocinium Demos v1.0</li>
                <li>Whiteboarding Plugin v1.0</li>
              </ul>
            </div>
          }
          <!-- General Tab -->
          @case ('tab-general') {
            <div>
              <app-general-settings></app-general-settings>
            </div>
          }
          <!-- Illum Live Tab -->
          @case ('tab-arcangel') {
            <div>
              <app-arcangel-settings></app-arcangel-settings>
            </div>
          }
          <!-- Alerts Tab -->
          @case ('tab-alerts') {
            <div>
              <app-alerts-settings></app-alerts-settings>
            </div>
          }
          <!-- Default -->
          @default {
            <div>
              <p>Select a tab to view its content.</p>
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>